import { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const { error: authError } = await signIn(email, password);

    if (authError) {
      setError("E-mail ou senha inválidos. Tente novamente.");
      setLoading(false);
    } else {
      navigate("/admin");
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">

        {/* SEM LOGO */}
        <div className="text-center mb-10">
          <p className="text-[10px] tracking-[0.25em] text-black/40 uppercase">
            Área Administrativa
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-[10px] tracking-[0.2em] text-black/50 mb-2 uppercase">
              E-mail
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@raymeloboutique.com"
              className="w-full border-b border-black/20 bg-transparent py-2 text-sm tracking-wide outline-none focus:border-black transition-colors placeholder:text-black/20"
            />
          </div>

          <div>
            <label className="block text-[10px] tracking-[0.2em] text-black/50 mb-2 uppercase">
              Senha
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              className="w-full border-b border-black/20 bg-transparent py-2 text-sm tracking-wide outline-none focus:border-black transition-colors placeholder:text-black/20"
            />
          </div>

          {error && (
            <p className="text-xs text-red-500 tracking-wide">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-black text-white text-[11px] tracking-[0.25em] uppercase py-3 hover:bg-black/80 transition-colors cursor-pointer mt-2 whitespace-nowrap disabled:opacity-50"
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>

        <p className="text-center text-[10px] tracking-wide text-black/30 mt-8">
          Acesso restrito
        </p>
      </div>
    </div>
  );
}